import { VcCommunicator } from "./vccommunicator";

/**
 * Support ticket portal API methods (design doc §12.1-§12.3), mirroring the pattern in
 * vccommunicator_account.js. sessionId is attached automatically by retrieveData() when a
 * session exists - the backend derives requester identity from it, ignoring any other
 * client-supplied identity.
 */
VcCommunicator.prototype.getSupportTicketSchema = function () {
	var me = this;
	return me.retrieveData(me.createUrl("supportticket/schema"), {}, "application/json", "GET");
};

VcCommunicator.prototype.submitSupportTicket = function (payload) {
	var me = this;
	return me.retrieveData(me.createUrl("supportticket/submit"), payload, "application/json", "POST");
};

// AI pre-submit check (advisory only) - same payload shape as submitSupportTicket.
VcCommunicator.prototype.triageSupportTicket = function (payload) {
	var me = this;
	return me.retrieveData(me.createUrl("supportticket/triage"), payload, "application/json", "POST");
};

VcCommunicator.prototype.listMySupportTickets = function (status, page) {
	var me = this;
	// retrieveData appends sessionId/ginfo via its own "?" for GET requests, so extra query
	// params must go through the data object (merged into one query string) rather than being
	// appended to the url string directly, which produced a malformed "?a=1?sessionId=..." url.
	var params = {};
	if (status) params.status = status;
	if (page) params.page = page;
	return me.retrieveData(me.createUrl("supportticket/list"), params, "application/json", "GET");
};

VcCommunicator.prototype.getMySupportTicket = function (ticketId) {
	var me = this;
	return me.retrieveData(me.createUrl("supportticket/" + ticketId), {}, "application/json", "GET");
};

VcCommunicator.prototype.replyToSupportTicket = function (ticketId, body, attachmentTokens) {
	var me = this;
	return me.retrieveData(me.createUrl("supportticket/" + ticketId + "/reply"),
		{ body: body, attachmentTokens: attachmentTokens || [] }, "application/json", "POST");
};

// Uses fetch()+FormData directly rather than routing through retrieveData/retrieveDataMultiPart -
// those build the multipart body as a JS string, which corrupts binary file content; the browser's
// native FormData/fetch handles binary encoding correctly. existingToken chains multiple files from
// the same ticket/reply into a single Zendesk upload group (see ZendeskRequestsClient.uploadFile).
VcCommunicator.prototype.uploadSupportTicketAttachment = function (file, existingToken) {
	var formData = new FormData();
	formData.append("file", file, file.name);
	if (existingToken) {
		formData.append("existingToken", existingToken);
	}
	return fetch(this.createUrl("supportticket/upload"), {
		method: "POST",
		mode: "cors",
		cache: "no-cache",
		body: formData,
	}).then(function (response) {
		return response.text();
	}).then(function (text) {
		var data;
		try {
			data = JSON.parse(text);
		} catch (e) {
			throw new Error(text ? text.substring(0, 1024) : "Unexpected upload response");
		}
		if (data.errorCode) {
			throw new Error(data.message || "Upload failed");
		}
		return data;
	});
};
